import { useKnowledgeDocumentUXContextOptional } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'

import { useIsolationController } from './IsolationControllerContext'

export function useIsGraphModeEnabled(): boolean {
  const graphMode = useKnowledgeDocumentUXContextOptional()?.graphMode ?? false
  const isolating = useIsolationController() !== undefined
  return graphMode || isolating
}
